/**
 *
 * TextWithCopyAction
 *
 */
import React, { CSSProperties, memo, ReactNode } from 'react';
import { useTheme } from '@mui/material';
import { CopyIcon as DefaultCopyIcon } from '../Icons/UtilsIcons';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { IconText } from '../IconText';
import { NestedCssProperties } from '../../../styles/makeThemeStyle';

interface Props {
  text: string | undefined;
  CustomCopyIcon?: ReactNode;
  textStyle?: NestedCssProperties<CSSProperties>;
}

export const TextWithCopyAction = memo((props: Props) => {
  const { text, CustomCopyIcon } = props;
  const theme = useTheme();

  const IconButton = React.useMemo(() => {
    const element = CustomCopyIcon ? CustomCopyIcon : <DefaultCopyIcon />;
    return (
      <CopyToClipboard text={text}>
        <span data-testid="copy-action-icon">{element}</span>
      </CopyToClipboard>
    );
  }, [CustomCopyIcon, text]);

  if (!text) {
    return null;
  }

  return (
    <>
      <IconText
        text={text}
        icon={IconButton}
        wrapperStyle={{
          color: 'unset',
        }}
        textStyle={{
          order: 1,
          fontSize: 'inherit',
          fontWeight: 'unset',
          width: '80%',
          maxWidth: 'max-content',
          ...props.textStyle,
        }}
        iconStyle={{
          order: 2,
          marginLeft: theme.spacing(1),
          '&:hover': {
            color: theme.palette.primary.main,
          },
        }}
      />
    </>
  );
});
